import React from 'react';

export const DataSheetPreview = () => {
  return (
    <>
      <div>DataSheetPreview</div>
    </>
  );
};
